import React, {useEffect } from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import Poster from './Components/Poster/Poster';
import Footer from './Components/Footer/Footer';
import Aboutus from './Components/Aboutus/Aboutus';
import Services from './Components/Services/Services';
import ContactUs from './Components/Contactus/Contactus';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus/>} />
        <Route path="/services" element={<Services/>} />
        <Route path="/services/:serviceId" element={<Services />} />
        <Route path="/contactus" element={<ContactUs/>} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
